function beforeUnloadHandler(e: BeforeUnloadEvent) {
  e.preventDefault();
}

export function enableUnloadPrompt() {
  window.addEventListener("beforeunload", beforeUnloadHandler);
}

export function disableUnloadPrompt() {
  window.removeEventListener("beforeunload", beforeUnloadHandler);
}
